import React, { useState, useEffect } from 'react';
import {
    FormControlLabel, Checkbox, TextField, InputAdornment, Box, Dialog, DialogTitle, DialogContent, FormControl,
    RadioGroup, Radio, DialogActions, Avatar, Slide, Tooltip,
    Menu,
    MenuItem
} from "@mui/material";
import { FaStar } from 'react-icons/fa';
import SmsIcon from '@mui/icons-material/Sms';
import EmailIcon from '@mui/icons-material/Email';
import { MdOutlinePhoneIphone } from "react-icons/md";
import PublicIcon from '@mui/icons-material/Public';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { ReactComponent as WhatsappFilled } from '../../../Assets/img/icons/whatsapp-filled.svg';
import { ReactComponent as VideoCallFilled } from '../../../Assets/img/icons/video-call-figma.svg';
import { ReactComponent as PaymentFilled } from '../../../Assets/img/icons/payment-icon-figma.svg';
import VolumeUpRoundedIcon from '@mui/icons-material/VolumeUpRounded';
import ForumIcon from '@mui/icons-material/Forum';
import { ReactComponent as GroupChatFilled } from '../../../Assets/img/icons/group-chat-figma.svg';
import { ReactComponent as VideoTutorialFilled } from '../../../Assets/img/icons/video-tutorial-figma.svg';
import { FaSearch } from "react-icons/fa";
import VerifiedIcon from '@mui/icons-material/Verified';
import { useQuantityContext } from '../../QuantityContext';
import MoreVertIcon from '@mui/icons-material/MoreVert';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import useApi from '../../Utilities/useAPI';
import { Button, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import BlockIcon from '@mui/icons-material/Block';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Typography from "@mui/material/Typography";
import CloseIcon from '@mui/icons-material/Close';
import "cropperjs/dist/cropper.css";
import { useNavigate } from 'react-router-dom';
import { ReactComponent as FavouriteStar } from "../../../Assets/img/icons/Favourites star icon.svg";
import { ReactComponent as NonVerifiedTickNew } from "../../../Assets/img/icons/Non-verified-icon.svg";
import CryptoJS from 'crypto-js';
import SpeedDialComponent from './SubPages_Contacts/SpeedDialComponent';
import { motion, AnimatePresence } from "framer-motion";
import AllContactsGroupSkeleton from '../../LoadingSkeleton/AllContactsGroupSkeleton';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';


function AllContactsGroup() {
    const { isEnabledCCE, ContactView, sortOrder, filteredGroups, sortDateOrder, latestDateOrder } = useQuantityContext();

    // For demonstration, assuming we fetched group details from an API
    // In reality, you would fetch this from your backend
    const group = []; // Replace with actual data fetching logic
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredMembers, setFilteredMembers] = useState(group);
    const [showDetails, setShowDetails] = useState(isEnabledCCE);
    const [isListView, setIsListView] = useState(ContactView === "List View"); // State to toggle list view
    const [expandedItem, setExpandedItem] = useState(null); // State to track expanded item
    const [openOverflowIndex, setOpenOverflowIndex] = useState([]);
    const [selectedItems, setSelectedItems] = useState({});  // Initialize with an empty object for item selection
    const [selectAll, setSelectAll] = useState(false);        // State for "Select" checkbox
    const [selectAllMembers, setSelectAllMembers] = useState(false);        // State for "Select All" checkbox
    const [groupMembers, setGroupMembers] = useState([]);
    const dispatch = useDispatch();
    const [deleteConfirm, setdeleteConfirm] = useState(false);
    const [muteContact, setMuteContact] = useState(false);
    const { callApiFunction } = useApi();
    const [showOptionsBar, setShowOptionsBar] = useState(false)
    const [loading, setLoading] = useState(true);
    const Connectedcontact = useSelector((state) => state?.ContactArray?.ConnectedContact);


    // useEffect(() => {
    //     if (openOverflowIndex.length > 0) {
    //       setLoading(false);
    //     }
    //   }, [openOverflowIndex]);
    const [anchorEl, setAnchorEl] = useState(null);
    const isMenuOpen = Boolean(anchorEl);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const cceFunctions = [
        { icon: VideoCallFilled, function: undefined },
        { icon: WhatsappFilled, function: undefined },
        { icon: ForumIcon, function: undefined },
        { icon: GroupChatFilled, function: undefined },
        { icon: AttachFileIcon, function: undefined },
        { icon: VideoTutorialFilled, function: undefined },
        { icon: VolumeUpRoundedIcon, function: undefined },
        { icon: EmailIcon, function: undefined },
    ];

      const onMemberClick = (member) => {
    handleNavigate(member.contact_ref_id); // or navigate to chat
  };

    // Handle "Select All" logic
    const handleSelectAllChange = () => {
        // const newSelectedItems = {};
        // filteredMembers.forEach((member) => {
        //     newSelectedItems[member.contact_ref_id] = !selectAll;  // Use contact_ref_id instead of email
        // });
        // setSelectedItems(newSelectedItems);

        if (selectAll) {
            setSelectedItems("")
            setSelectAllMembers(false);
        }

        setSelectAll(!selectAll);
    };

    const handleSelectAll = () => {
        // Select all members
        if (!selectAllMembers) {
            const newSelectedItems = {};
            filteredMembers.forEach((member) => {
                newSelectedItems[member.contact_ref_id] = true; // Use `contact_ref_id` or unique identifier
            });
            setSelectedItems(newSelectedItems);
        } else {
            setSelectedItems("");
        }

        setSelectAllMembers(!selectAllMembers)
    }


    // Handle individual item selection
    const handleItemSelection = (contact_ref_id) => {
        const newSelectedItems = { ...selectedItems, [contact_ref_id]: !selectedItems[contact_ref_id] };
        setSelectedItems(newSelectedItems);

        // Update Select All state if needed
        // const allSelected = filteredMembers.every((member) => newSelectedItems[member.contact_ref_id]);
        // setSelectAll(allSelected);
        const hasSelectedItems = Object.values(newSelectedItems).some(isSelected => isSelected);
        setShowOptionsBar(hasSelectedItems);
    };

    useEffect(() => {
        setShowDetails(isEnabledCCE);
    }, [isEnabledCCE]);

    useEffect(() => {
        setIsListView(ContactView === "List View");
    }, [ContactView]);

    useEffect(() => {
        setFilteredMembers(
            groupMembers.filter(member =>
                member.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                member.role.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    }, [searchTerm, groupMembers]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    function generateRandomDate() {
        const start = new Date(2020, 0, 1); // Start date (1st January 2020)
        const end = new Date(); // Current date
        const randomDate = new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));

        // Format the date as 'Apr 21, 2024'
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return randomDate.toLocaleDateString('en-US', options);
    }

    const toggleOverflow = (index) => {
        setOpenOverflowIndex((prev) => {
            const newState = [...prev];
            newState[index] = !newState[index];
            return newState;
        });
    };

    const toggleExpand = (index) => {
        if (expandedItem === index) {
            setExpandedItem(null); // Collapse if already expanded
        } else {
            setExpandedItem(index); // Expand the clicked item
        }
    };

    useEffect(() => {
        // Fetch contacts from the API
        const fetchContacts = async () => {
            try {
                // const response = await callApiFunction('ConnectedContacts');
                // const data = response;
                // if (data.statusCode === 200) {
                const members = Connectedcontact.map(member => {
                    const role = member.designation || member.field_of_study || member.title || '---';
                    const subTitle = member.company || member.institute || member.nickname || '---';

                    return {
                        img: member.profile_url,
                        contact_ref_id: member.contact_ref_id,
                        name: `${member.first_name} ${member.last_name}`,
                        role: role, // Based on the new logic
                        verified: member.is_verified ? true : false,
                        is_favourite: member?.is_favourite ? true : false,
                        subTitle: subTitle, // Added subtitle for the new requirement
                        phone_no: member.phone_no?.replace(/[\s-]/g, ''),
                        email: member?.email,
                    };
                });

                setGroupMembers(members);
                setFilteredMembers(members);
                setLoading(false)
                // }
            } catch (err) {
                console.log('An error occurred while sending the connection request:', err);
            }
        };

        fetchContacts();
    }, []);

    const handleDelete = async () => {
        const contact_ref_ids = Object.keys(selectedItems)
            .filter(id => selectedItems[id])
            .map(id => parseInt(id, 10)); // Ensure IDs are integers

        // Update selectedGroupMembers and filteredMembers by removing deleted contacts
        setGroupMembers((prevMembers) => {
            const updatedMembers = prevMembers.filter((member) => !contact_ref_ids.includes(member.contact_ref_id));
            return updatedMembers;
        });

        setFilteredMembers((prevMembers) => {
            const updatedMembers = prevMembers.filter((member) => !contact_ref_ids.includes(member.contact_ref_id));
            return updatedMembers;
        });

        // Optionally, clear the selected items if needed
        setSelectedItems((prevSelectedItems) => {
            const updatedSelectedItems = { ...prevSelectedItems };
            contact_ref_ids.forEach(id => {
                delete updatedSelectedItems[id];
            });
            return updatedSelectedItems;
        });

        setdeleteConfirm(false);
        try {
            const response = await callApiFunction('deleteContacts', {
                contact_ref_ids: contact_ref_ids,
            });
            // console.log("Deleted Successfully", response);
            navigate('/contacts')
        } catch (error) {
            console.log('Error uploading file:', error.message);
        }

    }

    const handleSaveMute = () => {
    }
    const selectedContacts = Object.keys(selectedItems).filter(key => selectedItems[key]);

    const toggleFavoriteStatus = async (contact_ref_id, currentStatus) => {
        try {
            // Update favorite status locally after the API call succeeds
            setGroupMembers((prevMembers) =>
                prevMembers.map((member) =>
                    member.contact_ref_id === contact_ref_id
                        ? { ...member, is_favourite: !member.is_favourite }
                        : member
                )
            );
            setFilteredMembers((prevMembers) =>
                prevMembers.map((member) =>
                    member.contact_ref_id === contact_ref_id
                        ? { ...member, is_favourite: !member.is_favourite }
                        : member
                )
            );
            const response = await callApiFunction('favouriteContact', {
                is_favourite: !currentStatus,
                contact_ref_id: contact_ref_id
            });
            // console.log("Favourite Card Updated", response.message);
        } catch (err) {
            console.log('Error updating favorite status:', err);
        }
    };

    useEffect(() => {
        // console.log("SORTED STATUS", sortOrder);

        if (sortOrder !== null) {
            // Extract group names or the necessary data
            const sortedCards = filteredMembers.sort((a, b) => {
                if (sortOrder === 'ascending') {
                    return a.name.localeCompare(b.name); // Replace with the correct property
                } else {
                    return b.name.localeCompare(a.name); // Replace with the correct property
                }
            });

            // console.log("Sorted Cards:", sortedCards);
            // setOtherCards(sortedCards);
            // Uncomment this to update the state
        }
    }, [sortOrder, filteredMembers]);


    useEffect(() => {
        if (sortDateOrder !== null) {
            const sortedCards = filteredMembers.sort((a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);

                return sortDateOrder === 'ascending' ? dateA - dateB : dateB - dateA;
            });

            // console.log("Sorted by Created Date:", sortedCards);
            // setOtherCards(sortedCards); 
            // Uncomment to update state
        }
    }, [sortDateOrder, filteredMembers]);


    useEffect(() => {
        if (latestDateOrder !== null) {
            const sortedCards = filteredMembers.sort((a, b) => {
                const dateA = new Date(a.modified_at);
                const dateB = new Date(b.modified_at);

                return latestDateOrder === 'latestDate' ? dateB - dateA : dateA - dateB;
            });

            // console.log("Sorted by Modified Date:", sortedCards);
            // setOtherCards(sortedCards); 
            // Uncomment to update state
        }
    }, [latestDateOrder, filteredMembers]);

    const handleNavigate = (id) => {
        const encryptedId = CryptoJS.AES.encrypt(id.toString(), 'UserDetailsSecretKey').toString();
        navigate(`/userDetailedInfo?encryptedId=${encodeURIComponent(encryptedId)}`);
        // navigate(`/userDetailedInfo/${id}`)
    }

    const cardVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: 50 },
    };

    if (loading) {
        return <AllContactsGroupSkeleton />
    }
    return (
        <div className="outer-layer-of-contacts">
            <div className="outer-container">
                <div className="displayflex justify-content-between align-items-center">
                    <h6 className="fw-bold">All Contacts</h6>
                    <motion.div className="flex-center" initial={{ opacity: 0, y: 50 }} // Start below with opacity 0
                        animate={{ opacity: 1, y: 0 }} // Animate to original position and full opacity
                        transition={{ duration: 0.8, ease: "easeOut" }} >
                        {!isListView &&
                            <div className="">
                                {(selectAll) ? <FormControlLabel
                                    className='customized_formControl'
                                    control={<Checkbox checked={selectAllMembers} onChange={handleSelectAll} />}
                                    label="Select All"
                                /> : <> </>}
                                <FormControlLabel
                                    className='customized_formControl'
                                    control={<Checkbox checked={selectAll} onChange={handleSelectAllChange} />}
                                    label="Select"
                                />
                            </div>}
                        <div style={{ marginRight: '10px' }}>
                            <TextField
                                placeholder="Search..."
                                variant="outlined"
                                size="small"
                                className="me-2"
                                value={searchTerm}
                                onChange={handleSearchChange}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <div className="icon">
                                                <FaSearch className="icon-color" />
                                            </div>
                                        </InputAdornment>
                                    ),
                                }}
                                style={{ width: '320px' }}
                            />
                        </div>
                    </motion.div>
                </div>

                {!isListView ? (
                    <div className="avatars-container">
                        <AnimatePresence>
                            {filteredMembers.map((member, index) => (
                                <motion.div
                                    key={member.contact_ref_id}
                                    className={`avatar-box-outer ${!showDetails ? 'compact' : ''}`}
                                    initial="hidden"
                                    animate="visible"
                                    exit="exit"
                                    variants={cardVariants}
                                    transition={{
                                        delay: index * 0.1, // Delay each card slightly for a staggered effect
                                        duration: 0.5,
                                    }}
                                >
                                    <div className={`avatar-box t ${!showDetails ? 'compact' : ''}`}>
                                        <div className="flex-center avatar-details-wrapper pointer" onClick={() => { handleNavigate(member.contact_ref_id) }}>

                                            {(selectAll || selectAllMembers) ? (
                                                <div className="dot_status_contacts">
                                                    <Checkbox
                                                        checked={selectedItems[member.contact_ref_id] || false}
                                                        onClick={(e) => e.stopPropagation()} // Prevent click propagation
                                                        onChange={(e) => {
                                                            e.stopPropagation(); // Stop event from bubbling up
                                                            handleItemSelection(member.contact_ref_id);
                                                        }}
                                                        className="member-checkbox p-0"
                                                    />
                                                </div>
                                            ) : (
                                                <div className="dot_status_contacts"
                                                    style={{ backgroundColor: member.verified ? "#43A047" : "#EB4E3D" }}></div>
                                            )}

                                            <div className='star_fav_cards' onClick={(e) => {
                                                e.stopPropagation();
                                                toggleFavoriteStatus(member.contact_ref_id, member.is_favourite)
                                            }}>
                                                {member.is_favourite ? (
                                                    <FaStar color={"#FCB809"} style={{ width: "20px", height: "20px" }} />
                                                ) : (
                                                    <FavouriteStar />
                                                )}
                                            </div>
                                            <div className="avatar-details t">
                                                <div>
                                                    <div className="avatar-image t">
                                                        {/* <img className='cover-image' src={member.img} alt={member.name} /> */}
                                                        <Avatar
                                                            className="w-100 h-100 cover-image" style={{ fontSize: "3rem" }}
                                                            alt={member.name}
                                                            src={member.img || undefined}
                                                        >{member.name.charAt(0).toUpperCase()}</Avatar>
                                                    </div>
                                                    <div className={`symbol_of_contacts ${!showDetails ? 'compact' : ''}`}>
                                                        {member.verified ?
                                                            <VerifiedIcon style={{ color: "#43A047" }} /> :
                                                            <NonVerifiedTickNew />
                                                        }
                                                    </div>
                                                </div>
                                                {/* {showDetails && <div className="vertical-line"></div>} */}
                                                <div className="member-info word-break">
                                                    <Tooltip title={member.name} placement="bottom">
                                                        <div className="member-name">
                                                            {member.name.length > 10
                                                                ? `${member.name.slice(0, 10)}...`
                                                                : member.name}
                                                        </div>
                                                    </Tooltip>
                                                    <div className="member-role">{member.role}</div>
                                                    {showDetails && <div className="member-email truncate">{member.subTitle}</div>}
                                                </div>
                                            </div>
                                        </div>

                                        {showDetails && (
                                            <>
                                                <div className="icons-container">
                                                    {[
                                                        { href: `tel:${member?.phone_no}`, icon: <MdOutlinePhoneIphone className="icon" /> },
                                                        { href: `sms:${member?.phone_no}`, icon: <SmsIcon className="icon" /> },
                                                        { href: `mailto:${member?.email}`, icon: <EmailIcon className="icon" /> },
                                                        { href: `https://wa.me/${member?.phone_no}`, icon: <WhatsappFilled className="icon figma-icon" /> },
                                                    ].map((item, idx) => (
                                                        <a key={idx} href={item.href || '#'} target='_blank' rel='noreferrer' className='icon-box flex-center flex-column'>
                                                            {item.icon}
                                                        </a>
                                                    ))}
                                                    <div className="icon-box flex-center flex-column">
                                                        <MoreHorizIcon className="icon" onClick={() => toggleOverflow(index)} />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                    {showDetails && openOverflowIndex[index] && (
                                        <>
                                            <div className="overflow-menu icons-container ms-2">
                                                {[
                                                    { icon: <AttachFileIcon className="icon" /> },
                                                    { icon: <PublicIcon className="icon" /> },
                                                    { icon: <VideoCallFilled className="icon" /> },
                                                    { icon: <VolumeUpRoundedIcon className="icon" /> },
                                                    { icon: <PaymentFilled className="icon figma-icon" /> },
                                                ].map((item, index) => (
                                                    <div key={index} className="icon-box">
                                                        {item.icon}
                                                    </div>
                                                ))}
                                            </div>
                                        </>
                                    )}
                                </motion.div>
                            ))}
                        </AnimatePresence>
                    </div>
                ) : (
                    <div className="list-container">
                        <ul className="members">
                            {/* Column headers */}
                            <div className="header-row">
                                <div className="header-column select-all me-3">
                                    <FormControlLabel
                                        className='customized_formControl ms-3'
                                        control={<Checkbox checked={selectAllMembers} onChange={handleSelectAll} className='ps-0' />}
                                        label="Select All"
                                    />
                                </div>
                                <div className="header-column name-email-details-column">
                                    Name and Email
                                </div>
                                <div className="header-column name-email-details-column">
                                    Details
                                </div>
                                <div className="header-column date">
                                    Date
                                </div>
                                <div className="header-column actions">
                                    Actions
                                </div>
                            </div>
                            {filteredMembers.map((member, index) => (
                                <div key={index} className={`list-item-container ${expandedItem === index ? 'expanded' : ''}`}>
                                    <li key={index} className={`list-item ${expandedItem === index ? 'expanded' : ''}`} onClick={() => { handleNavigate(member.contact_ref_id) }}>
                                        <div className='d-flex align-items-center header-column select-all ms-3' style={{ position: "relative" }}>
                                            <Checkbox onClick={(e) => e.stopPropagation()} // Prevent click propagation
                                                checked={selectedItems[member.contact_ref_id] || false}  // Changed to contact_ref_id
                                                onChange={() => handleItemSelection(member.contact_ref_id)}  // Changed to contact_ref_id
                                                className="member-checkbox p-0"
                                            />
                                            <div className="list-avatar" style={{ position: "absolute", right: "10%" }}>
                                                <div className='w-100 h-100' style={{ position: "relative" }}>
                                                    <Avatar style={{ fontSize: "2rem" }}
                                                        className="w-100 h-100 cover-image"
                                                        alt={member.name}
                                                        src={member.img || undefined}
                                                    >{member.name.charAt(0).toUpperCase()}</Avatar>

                                                    <div className={`symbol_of_contacts2_list`}>
                                                        {member.verified ?
                                                            <VerifiedIcon style={{ color: "#43A047" }} /> :
                                                            <NonVerifiedTickNew />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="name-email-details header-column name-email-details-column">
                                            <span className="list-name">{member.name}</span>
                                            <span className="list-txt">{member.subTitle}</span>

                                        </div>
                                        <span className="list-role header-column name-email-details-column">{member.role}</span>
                                        <span className="list-date header-column date" onClick={(e) => e.stopPropagation()}>
                                            {/* {generateRandomDate()} */}
                                            Nov 1, 2020
                                        </span>
                                        <span className="list-actions header-column actions align-items-center icon-20px" onClick={(e) => e.stopPropagation()}>
                                            {member.is_favourite ? (
                                                <FaStar color={"#FCB809"} style={{ width: "20px", height: "20px" }} onClick={() => { toggleFavoriteStatus(member.contact_ref_id, member.is_favourite); }} />
                                            ) : (
                                                <FavouriteStar onClick={() => { toggleFavoriteStatus(member.contact_ref_id, member.is_favourite); }} />
                                            )}
                                            <MoreVertIcon className={`ms-2 ${expandedItem === index ? 'color-blue' : 'icon-color'}`} onClick={() => toggleExpand(index)} />
                                        </span>

                                        {expandedItem === index && (
                                            <div className="group-options-bar additional-info">
                                                <a href={`mailto:${member?.email}`} target='_blank' rel='noreferrer'>
                                                    <div className="group-option-box" onClick={(e) => e.stopPropagation()} >
                                                        <EmailIcon className="pointer" />
                                                    </div>
                                                </a>
                                                <a href={`https://wa.me/${member?.phone_no}`} target='_blank' rel='noreferrer' >
                                                    <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                        <WhatsappFilled className="pointer figma-icon" />
                                                    </div>
                                                </a>
                                                <a href={`sms:${member?.phone_no}`} target='_blank' rel='noreferrer' >
                                                    <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                        <GroupChatFilled className="pointer figma-icon" />
                                                    </div>
                                                </a>
                                                <a href={`sms:${member?.phone_no}`} target='_blank' rel='noreferrer' >
                                                    <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                        <ForumIcon className="pointer" />
                                                    </div>
                                                </a>
                                                <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                    <VolumeUpRoundedIcon className="pointer" />
                                                </div>
                                                <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                    <VideoTutorialFilled className="pointer figma-icon" />
                                                </div>
                                                <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                    <AttachFileIcon className="pointer figma-icon" />
                                                </div>
                                                <div className="group-option-box" onClick={(e) => e.stopPropagation()}>
                                                    <VideoCallFilled className="pointer figma-icon" />
                                                </div>
                                            </div>
                                        )}
                                    </li>
                                </div>
                            ))}
                        </ul>
                    </div>
                )}
                <Slide direction="left" in={false} mountOnEnter unmountOnExit>
                    <div className={`group-options-bar ${showOptionsBar === true ? 'show-options' : ''}`} style={{ top: '80px', right: '0px' }}>
                        <div className="group-option-box">
                            <VideoCallFilled className="pointer figma-icon" />
                        </div>

                        <div className="group-option-box">
                            <WhatsappFilled className="pointer figma-icon" />
                        </div>
                        <div className="group-option-box">
                            <ForumIcon className="pointer" />
                        </div>
                        <div className="group-option-box">
                            <GroupChatFilled className="pointer figma-icon" />
                        </div>
                        <div className="group-option-box">
                            <AttachFileIcon className="pointer figma-icon" />
                        </div>
                        <div className="group-option-box">
                            <VideoTutorialFilled className="pointer figma-icon" />
                        </div>
                        <div className="group-option-box">
                            <VolumeUpRoundedIcon className="pointer" />
                        </div>
                        {/* <a href={`mailto:${member?.email}`} target='_blank' rel='noreferrer' className='icon-box flex-center flex-column' > */}
                        <div className="group-option-box">
                            <EmailIcon className="pointer" />
                        </div>
                        {/* </a> */}
                    </div>
                </Slide>
            </div>

            {selectedContacts.length > 0 && (
                <div className={`action-bar cce-actions ${Object.keys(selectedItems).length > 0 ? 'open' : ''}`}>
                    {cceFunctions.map((item, index) => {
                        const SvgIcon = item.icon; // Get the component reference
                        return (
                            <a href={item.href} target="_blank" rel="noreferrer" key={index}>
                                <IconButton className="white-icon-hover me-4" onClick={item.function} key={index}>
                                    <SvgIcon className='white-svg svg-icon-32px' />
                                </IconButton>
                            </a>
                        )
                    })}

                    <IconButton className="white-icon-hover me-4 position-absolute end-0" onClick={handleMenuOpen}>
                        <MoreVertIcon className='white-svg svg-icon-32px' />
                    </IconButton>

                    {/* Overflow Menu */}
                    <Menu
                        id="overflow-menu"
                        anchorEl={anchorEl}
                        open={isMenuOpen}
                        onClose={handleMenuClose}
                        MenuListProps={{
                            'aria-labelledby': 'overflow-menu-button',
                        }}
                    >
                        <MenuItem
                            onClick={() => {
                                setdeleteConfirm(true);
                                handleMenuClose();
                            }}
                            style={{ color: '#0044C6' }}
                        >
                            <DeleteIcon className='me-3' />
                            Delete
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                setMuteContact(true);
                                handleMenuClose();
                            }}
                            style={{ color: '#0044C6' }}
                        >
                            <VolumeOffIcon className='me-3' />
                            Mute
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                handleDelete();
                                handleMenuClose();
                            }}
                            style={{ color: '#0044C6' }}
                        >
                            <BlockIcon className='me-3' />
                            Block
                        </MenuItem>
                    </Menu>

                </div>
            )}

            <SpeedDialComponent />

            <LayoutBox deleteConfirm={deleteConfirm} setdeleteConfirm={setdeleteConfirm} handleDeleteCard={handleDelete}
                muteContact={muteContact} setMuteContact={setMuteContact} handleSaveMute={handleSaveMute} />
        </div>
    );
}

const LayoutBox = ({ deleteConfirm, setdeleteConfirm, handleDeleteCard, muteContact, setMuteContact, handleSaveMute }) => {

    const [selectedOption, setSelectedOption] = useState('');

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    };

    return (
        <>
            {deleteConfirm &&
                <div className="lightbox-overlay">
                    <div className="lightbox-content p-4" style={{ minWidth: "40%" }}>
                        <div className='d-flex align-items-center justify-content-between'>
                            <h6 className='mb-0' style={{ fontSize: "16px", fontWeight: "bold", color: "black" }}>Delete the Contact</h6>
                            <IconButton onClick={() => setdeleteConfirm(false)}>
                                <CloseRoundedIcon />
                            </IconButton>
                        </div>

                        <Typography variant="body2" className="text-muted">Person will be deleted from your Contact. Are you sure you want to delete?</Typography>

                        <div className='d-flex justify-content-end'>
                            <Button onClick={() => setdeleteConfirm(false)} className="mx-2 mt-2">
                                CANCEL
                            </Button>
                            <Button onClick={handleDeleteCard} className="delete-button_configuration mt-2">
                                DELETE
                            </Button>
                        </div>

                    </div>
                </div>
            }

            <Dialog open={muteContact} onClose={() => { setMuteContact(false) }} maxWidth="sm">
                <DialogTitle className='d-flex'>
                    Mute the Contact
                    <IconButton
                        aria-label="close"
                        onClick={() => { setMuteContact(false) }}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 10,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <FormControl component="fieldset">
                        <RadioGroup value={selectedOption} onChange={handleChange}>
                            <FormControlLabel value="1 hour" control={<Radio />} label="1 hour" />
                            <FormControlLabel value="8 hours" control={<Radio />} label="8 hours" />
                            <FormControlLabel value="7 days" control={<Radio />} label="7 days" />
                            <FormControlLabel value="indefinite" control={<Radio />} label="Until I Turn It Back On" />
                        </RadioGroup>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <div className='d-flex justify-content-end'>
                        <Button onClick={() => setMuteContact(false)} className="me-3" style={{ color: "#0044c6" }}>
                            CANCEL
                        </Button>
                        <Button onClick={() => { handleSaveMute(selectedOption) }} variant="contained" className='color-white' sx={{ backgroundColor: "#0044C6" }}
                            style={{ marginBottom: "10px", marginRight: "10px" }}>
                            Confirm
                        </Button>
                    </div>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default AllContactsGroup;